import React, {Component} from "react";
import OpenDataComponent from "../components/OpenDataComponent";

export class OpenData extends Component{
    render(){
        return(
            <OpenDataComponent />
        )
    }
}

export default OpenData;